import { createAction, handleActions } from 'redux-actions';
// api
import api from '../../utils/api';

const defaultParams = {
  per_page: 25,
  page: 1,
  filter: {}
};

const initialState = {
  myJournals: [],
  journalPrompts: {},
  meta: {
    total: 0,
    current: 0
  },
  journalPromptsFilter: '',
  activeNote: null,
  isLoading: false,
  params: defaultParams
};

// const
export const GET_MY_JOURNALS = 'journals/GET_MY_JOURNALS';
export const GET_JOURNAL_PROMPTS = 'journals/GET_JOURNAL_PROMPTS';
export const SET_PROMPTS_FILTER = 'journals/SET_PROMPTS_FILTER';
export const ADD_NOTE = 'journals/ADD_NOTE';
export const DELETE_NOTE = 'journals/DELETE_NOTE';
export const EDIT_NOTE = 'journals/EDIT_NOTE';
export const SET_ACTIVE_NOTE = 'journals/SET_ACTIVE_NOTE';

// action creators
export const getMyJournals = createAction(
  GET_MY_JOURNALS,
  (data = defaultParams) => {
    return {
      promise: api.journals.getMyJournals(data),
      data
    };
  }
);

export const getJournalPrompts = createAction(
  GET_JOURNAL_PROMPTS,
  api.journals.getJournalPrompts
);
export const setPromptsFilter = createAction(SET_PROMPTS_FILTER);
export const addNote = createAction(ADD_NOTE, api.journals.addNote);
export const setActiveNote = createAction(SET_ACTIVE_NOTE);
export const editNote = createAction(EDIT_NOTE, data => ({
  promise: api.journals.editNote(data),
  data
}));
export const deleteNote = createAction(DELETE_NOTE, data => ({
  promise: api.journals.deleteNote(data),
  data
}));

// reducer
const reducer = handleActions(
  {
    [`${GET_MY_JOURNALS}_REQUEST`]: (state, { payload }) => {
      return {
        ...state,
        params: payload,
        isLoading: true
      };
    },
    [`${GET_MY_JOURNALS}_SUCCESS`]: (
      state,
      { payload: { resources, meta } }
    ) => {
      return {
        ...state,
        meta,
        myJournals:
          meta.current === 1 ? resources : [...state.myJournals, ...resources],
        isLoading: false
      };
    },
    [`${GET_MY_JOURNALS}_ERROR`]: state => {
      return {
        ...state,
        isLoading: false
      };
    },
    [`${GET_JOURNAL_PROMPTS}_REQUEST`]: state => {
      return {
        ...state,
        journalPromptsFilter: '',
        isLoading: true
      };
    },
    [`${GET_JOURNAL_PROMPTS}_SUCCESS`]: (state, { payload }) => ({
      ...state,
      journalPrompts: payload,
      isLoading: false
    }),
    [`${GET_JOURNAL_PROMPTS}_ERROR`]: state => {
      return {
        ...state,
        isLoading: false
      };
    },
    [SET_PROMPTS_FILTER]: (state, { payload }) => {
      return { ...state, journalPromptsFilter: payload };
    },
    [`${ADD_NOTE}_SUCCESS`]: (state, { payload: { resource } }) => {
      const { myJournals } = state;
      return {
        ...state,
        myJournals: [resource, ...myJournals]
      };
    },
    [`${DELETE_NOTE}_REQUEST`]: (state, { payload: { id } }) => {
      const myJournals = state.myJournals.filter(note => note.id !== id);
      return {
        ...state,
        myJournals
      };
    },
    [`${EDIT_NOTE}_SUCCESS`]: (state, { payload: { resource } }) => {
      const myJournals = state.myJournals.map(
        note => (resource.id === note.id ? resource : note)
      );
      return {
        ...state,
        myJournals
      };
    },
    [SET_ACTIVE_NOTE]: (state, { payload }) => {
      return {
        ...state,
        activeNote: payload
      };
    }
  },
  initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/journals.js